import axios from 'axios';

const config = require('../../../config/config.js');
const { domain, header, headerFile } = config;

export default {
  async create(data) {
    let result = false;
    const url = domain + '/post';
    let formData = new FormData();

    formData.append('access_token', data.access_token);
    formData.append('status', data.status);
    if (typeof data.photos !== 'undefined') {
      data.photos.forEach((d) => {
        formData.append('photos[]', d);
      });
    }
    if (typeof data.videos !== 'undefined') {
      data.videos.forEach((d) => {
        formData.append('videos[]', d);
      });
    }
    if (typeof data.person_tag !== 'undefined') {
      formData.append('person_tag', data.person_tag);
    }

    if (data !== undefined && data !== null && data !== '') {
      result = await axios.post(url, formData, headerFile);
    }

    return result;
  },
  async load(data) {
    let result = false;
    const url = domain + '/get-post';

    if (data !== undefined && data !== null && data !== '') {
      result = await axios.post(url, data, header);
    }

    return result;
  },
  async createComment(data) {
    let result = false;
    const url = domain + '/post/comment';

    if (data !== undefined && data !== null && data !== '') {
      result = await axios.post(url, data, header);
    }

    return result;
  },
  async likePost(data) {
    let result = false;
    const url = domain + '/like';

    if (data !== undefined && data !== null && data !== '') {
      result = await axios.post(url, data, header);
    }

    return result;
  },
  async dislikePost(data) {
    let result = false;
    const url = domain + '/dislike';

    if (data !== undefined && data !== null && data !== '') {
      result = await axios.post(url, data, header);
    }

    return result;
  },
  async search(data) {
    let result = false;
    const url = domain + '/search';

    if (data !== undefined && data !== null && data !== '') {
      result = await axios.post(url, data, header);
    }

    return result;
  },
  async searchFilter(data) {
    let result = false;
    const url = domain + '/search/filters';

    if (data !== undefined && data !== null && data !== '') {
      result = await axios.post(url, data);
    }

    return result;
  },
  async pinPost(data) {
    let result = false;
    const url = domain + '/post/pin';

    if (data !== undefined && data !== null && data !== '') {
      result = await axios.post(url, data, header);
    }

    return result;
  },
  async unpinPost(data) {
    let result = false;
    const url = domain + '/post/unpin';

    if (data !== undefined && data !== null && data !== '') {
      result = await axios.post(url, data, header);
    }

    return result;
  },
  async reportPost(data) {
    let result = false;
    const url = domain + '/post/report';

    if (data !== undefined && data !== null && data !== '') {
      result = await axios.post(url, data, header);
    }

    return result;
  },
  async visitProfile(data) {
    let result = false;
    const url = domain + '/users/' + data.user_id;

    if (data !== undefined && data !== null && data !== '') {
      result = await axios.post(url, data, header);
    }

    return result;
  },
  async sharePost(data) {
    let result = false;
    const url = domain + '/post/share';

    if (data !== undefined && data !== null && data !== '') {
      result = await axios.post(url, data, header);
    }

    return result;
  },
  async mostLikedPost(data) {
    let result = false;
    const url = domain + '/post/most-liked';

    if (data !== undefined && data !== null && data !== '') {
      result = await axios.post(url, data, header);
    }

    return result;
  },
  async mostDislikedPost(data) {
    let result = false;
    const url = domain + '/post/most-disliked';

    if (data !== undefined && data !== null && data !== '') {
      result = await axios.post(url, data, header);
    }

    return result;
  },
  async mostSharedPost(data) {
    let result = false;
    const url = domain + '/post/most-shared';

    if (data !== undefined && data !== null && data !== '') {
      result = await axios.post(url, data, header);
    }

    return result;
  },
  async getReportedPost(data) {
    let result = false;
    const url = domain + '/post/get-report';

    if (data !== undefined && data !== null && data !== '') {
      result = await axios.post(url, data, header);
    }

    return result;
  },
  async deleteReport(data) {
    let result = false;
    const url = domain + '/post/report/delete';

    if (data !== undefined && data !== null && data !== '') {
      result = await axios.post(url, data, header);
    }

    return result;
  },
  async deletePost(data) {
    let result = false;
    const url = domain + '/post/report/hide';

    if (data !== undefined && data !== null && data !== '') {
      result = await axios.post(url, data, header);
    }

    return result;
  },
  async getAsset(data) {
    let result = false;
    const url = domain + '/users/' + data.user_id + '/asset';

    if (data !== undefined && data !== null && data !== '') {
      result = await axios.post(url, data, header);
    }

    return result;
  },
  async exportData(data) {
    let result = false;
    const url = domain + '/search/export';

    if (data !== undefined && data !== null && data !== '') {
      result = await axios.post(url, data, header);
    }

    return result;
  },
};
